const state = {
  list: {
    count: 0,
    data: []
  }
}

export default state
